"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventsjs = require("@pch/eventsjs");

var _eventsjs2 = _interopRequireDefault(_eventsjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DISPLAY_LIST = Symbol("displayables");
var CURRENT_PROMISE = Symbol("currentDisplayable");

/**
* This module represents a class for queueing up
* popups or "displayables" that should be shown in sequence.
* Each popup will be shown one at a time in the order
* they are added to the queue. 
* To display a popup, just enqueue your displayable function
* and it will be shown when it is it's turn to be shown.
*/

var DisplayQueue = function () {
    function DisplayQueue() {
        _classCallCheck(this, DisplayQueue);

        this[DISPLAY_LIST] = [];
        Object.assign(this, _eventsjs2.default, {
            EVENTS: {
                EMPTIED: "onEmpty"
            }
        });
    }

    /**
    * Add a displayable to the queue.
    * If the queue is currently empty, the displayable will be shown immediately
    *
    * @param function The Displayable should be a function that shows your popup and returns a Promise
    *   that resolves once the popup is closed/hidden
    * @param function callback when all displayables complete
    */


    _createClass(DisplayQueue, [{
        key: "enqueue",
        value: function enqueue(displayable, callback) {
            this[DISPLAY_LIST].push(displayable);
            this.displayAllInSequence(callback);
        }

        /**
        * Dequeue the next displayable and return it
        */

    }, {
        key: "dequeue",
        value: function dequeue() {
            return this[DISPLAY_LIST].shift();
        }

        /**
        * Returns current number of displayables waiting in the queue
        * not including the one currently being shown
        */

    }, {
        key: "count",
        value: function count() {
            return this[DISPLAY_LIST].length;
        }

        /**
        * Whether or not a displayable is currently being shown
        * and waited on
        */

    }, {
        key: "isCurrentlyDisplaying",
        value: function isCurrentlyDisplaying() {
            return !!this[CURRENT_PROMISE];
        }

        /**
        * Add a one-time callback to fire the next time the queue
        * empties out (all displayables finish showing)
        */

    }, {
        key: "addEmptiedCallback",
        value: function addEmptiedCallback(callback) {
            var _this = this;

            if (!callback) {
                return;
            }
            var _callback = function _callback() {
                _this.removeEvent(_this.EVENTS.EMPTIED, _callback);
                callback();
            };
            this.addEvent(this.EVENTS.EMPTIED, _callback);
        }

        /**
        * Display all the displayables in sequence
        *
        * @param function option callback to fire once all displayables are done
        */

    }, {
        key: "displayAllInSequence",
        value: function displayAllInSequence(callback) {
            if (this.count() > 0) {
                if (!this.isCurrentlyDisplaying()) {
                    this.displayNext(callback);
                } else {
                    this.addEmptiedCallback(callback);
                }
            } else {
                if (callback) {
                    callback();
                }
            }
        }

        /**
        * Prefer calling displayAllInSequence over this
        */

    }, {
        key: "displayNext",
        value: function displayNext(callback) {
            var _this2 = this;

            var displayable = this.dequeue();
            if (displayable) {
                var promise = displayable();
                this[CURRENT_PROMISE] = promise;
                promise.then(function () {
                    _this2.displayNext(callback);
                }).catch(function (err) {
                    _this2.displayNext(callback);
                });
            } else {
                this[CURRENT_PROMISE] = null;
                if (callback) {
                    callback();
                }
                this.fireEvent(this.EVENTS.EMPTIED);
            }
        }
    }]);

    return DisplayQueue;
}();

exports.default = DisplayQueue;